(function test() {
  let sto;
  let per;

  exports.init = configureStore => {
    const myStore = configureStore();
    sto = myStore.store;
    per = myStore.persistor;
  };

  exports.getStore = () => {
    return sto;
  };

  exports.getPersistor = () => {
    return per;
  };
}());
